export class ChangeDetectSupporter {
    checkedSpecific:boolean;
}
